import React, { useState, useEffect, useCallback, useContext } from 'react'
import ProductInfo from './ProductInfo'
import RelatedProduct from './RelatedProduct'
import { Link } from 'react-router-dom'
import { connect, useDispatch } from "react-redux";
import { useParams, useLocation } from 'react-router-dom';
import { IoCloseCircle } from 'react-icons/io5';
import { RatingStar } from "rating-star";
import ProgressBar from 'react-bootstrap/ProgressBar';
import * as actions from "../../../actions/service";
import * as user from "../../../actions/user";
import * as feedback from "../../../actions/feedback";
import _ from 'lodash'
import { AuthContext } from '../../../context/AuthContext';
import { IoCalendarOutline, IoTimeOutline, IoHappyOutline, IoClipboardOutline } from "react-icons/io5";
import Carousel from 'react-bootstrap/Carousel';
import { useHistory } from "react-router-dom"
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import parse from 'html-react-parser';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import API from '../../../utils/api';
import Swal from 'sweetalert2';
import pencil from '../../../assets/img/common/pencil.png'
import pencilgray from '../../../assets/img/common/pencilgray.png'
import Avatar from 'react-avatar';
import BookingModal from '../../../page/bookingModal';
import TodayDeal from '../../Fashion/TodayDeal';
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/bootstrap.css'
import Cookies from 'js-cookie'
import {Helmet} from "react-helmet";

const timeSlots = [
    { name: '9.00 AM', value: '9.00', disabled: false },
    { name: '9.30 AM', value: '9.30', disabled: false },
    { name: '10.00 AM', value: '10.00', disabled: false },
    { name: '10.30 AM', value: '10.30', disabled: false },
    { name: '11.00 AM', value: '11.00', disabled: false },
    { name: '11.30 AM', value: '11.30', disabled: false },
    { name: '12.00 PM', value: '12.00', disabled: false },
    { name: '12.30 PM', value: '12.30', disabled: false },
    { name: '1.00 PM', value: '13.00', disabled: false },
    { name: '1.30 PM', value: '13.30', disabled: false },
    { name: '2.00 PM', value: '14.00', disabled: false },
    { name: '2.30 PM', value: '14.30', disabled: false },
    { name: '3.00 PM', value: '15.00', disabled: false },
    { name: '3.30 PM', value: '15.30', disabled: false },
    { name: '4.00 PM', value: '16.00', disabled: false },
    { name: '4.30 PM', value: '16.30', disabled: false },
    { name: '5.00 PM', value: '17.00', disabled: false },
    { name: '5.30 PM', value: '17.30', disabled: false },
    { name: '6.00 PM', value: '18.00', disabled: false },
    { name: '6.30 PM', value: '18.30', disabled: false },
    { name: '7.00 PM', value: '19.00', disabled: false },
    { name: '7.30 PM', value: '19.30', disabled: false },
    { name: '8.00 PM', value: '20.00', disabled: false },
    { name: '8.30 PM', value: '20.30', disabled: false },
    { name: '9.00 PM', value: '21.00', disabled: false },
    { name: '9.30 PM', value: '21.30', disabled: false }
]


const ProductDetailsOne = (props) => {
    const location = useLocation();
    const { t, i18n } = useTranslation();
    const { getAuthUser, isAuthenticated, getCurrentBranch } = useContext(AuthContext)
    const authUser = getAuthUser()
    const isAuthentic = isAuthenticated()
    // const branch = getCurrentBranch()
    // const [count, setCount] = useState(1)
    const history = useHistory()
    const [service, setService] = useState({})
    const [productCount, setProductCount] = useState(0)
    const [myCart, setMycart] = useState([]);
    const [showReviewModal, setShowReviewModal] = useState(false);
    const [rating, setRating] = React.useState(0);
    const [reviewDesc, setReviewDesc] = React.useState("");
    const [byrating, setByrating] = React.useState({
        5: 0,
        4: 0,
        3: 0,
        2: 0,
        1: 0
    });

    const [totalcount, setTotalcount] = React.useState(0);
    const [averageRating, setAverageRating] = React.useState(0);
    const [step, setStep] = useState(11)
    const [slots, setSlots] = useState(timeSlots);
    const [selectedSlot, setSelectedSlot] = useState("");
    const [show, setShow] = useState(false);
    const [selected, setSelected] = useState(new Date());
    const [currentService, setCurrentService] = useState({});
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [mobile, setMobile] = useState("");
    const [countryCode, setCountryCode] = useState('')
    const [stylePath, setStylePath] = useState(Cookies.get('fj_lang') === 'ar' ? "/assets/css/bootstrap.rtl.min.css" : "/assets/css/bootstrap.min.css");
    const closeReviewModal = () => setShowReviewModal(false);
    const openReviewModal = () => setShowReviewModal(true);
    const onRatingChange = (score) => {
        setRating(score);
    };

    const submitReview = () => {

        // if (rating === 0) {
        //     toast("Star rating can not be empty");
        //     return
        // }
        // if (!reviewDesc) {
        //     toast("Please add review");
        //     return
        // }
        if (!name) {
            toast("Please add your name");
            return
        }
        if (!email) {
            toast("Please add your email");
            return
        }
        if (!mobile) {
            toast("Please add your mobile");
            return
        }
        let reviewObj = {
            rating: rating,
            description: reviewDesc,
            service: service.id,
            result: "",
            servicename: service.title.en,
            type: 'Treatment',
            name: name,
            email: email,
            mobile: mobile
        }

        props.addReview(reviewObj)
        setStep(13)
        //setShowReviewModal(false);
    };

    useEffect(() => {
       
        const onSuccess = (data) => {

            setService(data)

        }
        if (location?.state?.service) {
            setService(location.state.service)
            setProductCount(location?.state?.count)
            props.getByServiceId(location?.state?.service?.id)
            props.fetchById(location?.state?.service?.id, onSuccess)
        } else {
     
           
            let params = new URLSearchParams(location.search);
            let gid = params.get('gid');
            let uid = params.get('uid');
            let language = location.pathname.split("/").pop();

            let title =location.pathname.split("/")[2].replaceAll("-"," ")
              
            //start change language

            if(Cookies.get('fj_lang') != language){
                if (language === 'en') {
                    setStylePath("/assets/css/bootstrap.min.css")
                } else {
                    setStylePath("/assets/css/bootstrap.rtl.min.css")
                }
          
                Cookies.set('fj_lang', language)
                i18n.changeLanguage(language);
                window.location.reload(false);

            }
           
            //end change language
            API.service().getByTitle('^'+title+'$')
                .then(res => {
                
                  setService(res.data)
                })
                .catch(err => console.log(err))
            // props.fetchById(uid, onSuccess)
            // props.getByServiceId(uid)
        }


        setProductCount(props.count)
        setMycart(props.cartArray)

        // if (isAuthentic) {
        //     props.fetchCart(authUser.id)
        // }
        props.fetchRandomPackages({ status: 'active' })
    }, [location?.state?.service])


    useEffect(() => {
        var head = document.head;
        var link = document.createElement("link");

        link.type = "text/css";
        link.rel = "stylesheet";
        link.href = stylePath;

        head.prepend(link);
        document.getElementById("deafult-bs4").disabled = true;

        return () => { head.removeChild(link); }

    }, [stylePath]);


    useEffect(() => {
        setProductCount(props.cart[service.id])

    }, [props.cartArray])
    useEffect(() => {
        setTotalcount(0)
    
        setAverageRating(0)
        setByrating({
            5: 0,
            4: 0,
            3: 0,
            2: 0,
            1: 0
        })
        if (props.feedbacksMeta?.totalcount) {
            setAverageRating(props.feedbacksMeta.averageRating)
            setTotalcount(props.feedbacksMeta.totalcount)
        }

        if (props.feedbacksMeta.byrating) {
            setByrating(props.feedbacksMeta.byrating)
        }

    }, [props.feedbacksMeta])


    useEffect(() => {
        // if(isFocused){ 
        if (isAuthentic) {
            onDebounceUpdateUserCartt(myCart);
        }
        // }

    }, [myCart]);


    const onDebounceUpdateUserCartt = useCallback(_.debounce((cart) => {


        const onSuccess = () => { }
        props.updateUserCart(authUser.id, {
            cart: cart
        }, onSuccess)

    }, 300), []);


    const onPlus = () => {
        if (!isAuthentic) {
            history.push('/login')
            return
        }
        setMycart(myCart.concat([service.id]))

    };

    const onMinus = () => {

        myCart.splice(myCart.findIndex(a => a === service.id), 1);

        setMycart(_.without(myCart, _.find(myCart, service.id)))

    };

    const handleMobileChange = (value, data, event, formattedValue) => {

        setMobile(value)
        setCountryCode(data.dialCode)
    }

    useEffect(() => {
        if (!service.doctorId) {
            return
        }
        setSelectedSlot("")
        setSlots([])
      
        API.doctorbooking().getAvailableTimeSlots({
            doctor: service.doctorId[0],
            bookingDate: new Date(selected).toISOString().split('T')[0] + 'T00:00:00.000+00:00',
        })
            .then(res => {

                let booked = res.data
                //console.log('---->1',booked)
                let sl = timeSlots;
                if (new Date(selected).toISOString().split('T')[0] === new Date().toISOString().split('T')[0]) {

                    sl.filter((ele, index) => {
                        sl[index].disabled = false

                        if (parseInt(ele.value) < parseInt(moment(new Date()).format("HH:mm")) + 0.60) {
                            sl[index].disabled = true
                        } else {
                            if (booked.includes(ele.value)) {
                                sl[index].disabled = true
                            }
                        }
                    })
                } else {
                    sl.filter((ele, index) => {
                        sl[index].disabled = false
                        if (booked.includes(ele.value)) {
                            sl[index].disabled = true
                        }
                    })
                }

                console.log(sl)
                setSlots(sl)
            })
            .catch(err => console.log(err))

    }, [selected]);


    const confirmBooking = () => {
        API.doctorbooking().create({
            doctor: currentService.doctorId,
            services: [currentService.id],
            type: 'treatment',
            customer: authUser.id,
            bookingDate: new Date(selected).toISOString().split('T')[0] + 'T00:00:00.000+00:00',
            bookingTime: selectedSlot,
            status: 'pending',
        })
            .then(res => {
                handleClose()
                Swal.fire({
                    title: 'Thank you for booking!',
                    text: 'Our customer service agent will call you for appointment confirmation.',
                    icon: 'success',
                    showConfirmButton: true,

                })

            })
            .catch(err => console.log(err))


    };


    const enableBookAppointmentModal = (service) => {
        if (!isAuthentic) {
            history.push('/login')
            return
        }
        console.log(service)
        setCurrentService(service)

        setSelectedSlot("")
        setSelected(new Date())

        let sl = timeSlots;
        sl.filter((ele, index) => {
            sl[index].disabled = false

            if (parseInt(ele.value) < parseInt(moment(new Date()).format("HH:mm")) + 0.60) {
                sl[index].disabled = true
            }
        })
        setSlots(sl)

        setShow(true);
    }

    const handleClose = () => {
        setShow(false)
        setSelected(new Date())
        setSelectedSlot("")
    };

    return (
        <>
            <section id="product_single_one" className="ptb-100 pt-5">
            <Helmet>
            <link hrefLang="en-ae" href={process.env.REACT_APP_URL+'treatments/'+(service?.title?.en)?.replaceAll(' ', '-')?.toLowerCase()+'/en'} rel="alternate"></link>
                <link  hrefLang="ar-ae" href={process.env.REACT_APP_URL+'treatments/'+(service?.title?.en)?.replaceAll(' ', '-')?.toLowerCase()+'/ar'} rel="alternate"></link>
                <h1>{service?.seoh1?.en && service?.seoh1[i18n.language]}</h1>
                <title>{service?.seotitle?.en && service?.seotitle[i18n.language]}</title>
                <meta name="description" content={service?.seometa?.en && service?.seometa[i18n.language]} />
             
            </Helmet>

                <div className="container">
                    <div className="row area_boxed">
                        <div className="col-lg-6 col-12">
                            <div className="product_single_one_img">

                                <Carousel controls={true} nextLabel="" prevLabel="" variant="dark">
                                    {service?.gallary?.map((data, index) => (<Carousel.Item key={index}>
                                        <img
                                            className="d-block w-100"
                                            src={process.env.REACT_APP_IMG_URL + data}

                                        />
                                    </Carousel.Item>))}
                                </Carousel>
                            </div>
                        </div>
                        <div className="col-lg-6 col-12">
                            <div className="product_details_right_one">
                                <div className="modal_product_content_one">
                                    <h2>{service?.title?.en && service?.title[i18n.language]}</h2>
                                    {service?.categoryId?.title?.en && <h5 className='text-golden my-3'>{t('category')} : <span className='text-capitalize text-black'>{service?.categoryId?.title[i18n.language]}</span></h5>}
                                    {service.purpose?.en && <p className='mt-3 mb-3'><strong>{t('purpose')} :</strong> {service.purpose[i18n.language]} </p>}

                                    <div className='row'>
                                        {service.result?.en && <div className='col-lg-12 col-12 mb-3'>
                                            <div className='row mx-0'>
                                                <div >
                                                    <IoCalendarOutline size={25} color="#c8ae79" />
                                                </div>
                                                <div className='col-11'>
                                                    <p className='text-black'>{t('result')}</p>
                                                    <small >{service.result[i18n.language]}</small>
                                                </div>

                                            </div>

                                        </div>}
                                        {service.duration?.en && <div className='col-lg-12 col-12 mb-3'>

                                            <div className='row mx-0'>
                                                <div >
                                                    <IoTimeOutline size={25} color="#c8ae79" />
                                                </div>
                                                <div className='col-11'>
                                                    <p className='text-black'> {t('duration')}</p>
                                                    <small >{service.duration[i18n.language]}</small>
                                                </div>

                                            </div>
                                        </div>}
                                        {service.pain && service.pain !== 'None' && <div className='col-lg-12 col-12'>

                                            <div className='row mx-0'>
                                                <div >
                                                    <IoHappyOutline size={25} color="#c8ae79" />
                                                </div>
                                                <div className='col-11'>
                                                    <p className='text-black'>{t('pain')}</p>
                                                    <small >{service.pain}</small>
                                                </div>

                                            </div>
                                        </div>}
                                        {service.sessions?.en && <div className='col-lg-12 col-12 mb-3'>

                                            <div className='row mx-0'>
                                                <div >
                                                    <IoClipboardOutline size={25} color="#c8ae79" />
                                                </div>
                                                <div className='col-11'>
                                                    <p className='text-black'>{t('sessions')}</p>
                                                    <small >{service.sessions[i18n.language]}</small>
                                                </div>

                                            </div>
                                        </div>}
                                    </div>

                                    {false && service?.packageServices?.map((item, i) =>
                                        <Link key={i} to={{
                                            
                                            pathname: `/treatments/${(item?.title?.en)?.replaceAll(' ', '-')?.toLowerCase()}/${i18n.language}`, state: {
                                                service: item.serviceID,
                                                cartArray: myCart,
                                                count: _.countBy(myCart)[item?._id]
                                            }

                                        }} >
                                            <div className="row mb-4 border-bottom pb-4" >
                                                <div className='col-2'>
                                                    <img className='img-fluid' src={process.env.REACT_APP_IMG_URL + item?.serviceID?.image} />
                                                </div>
                                                <div className='col-10'>

                                                    <h5 className='pt-0'>{item?.serviceID?.title?.[i18n.language]}</h5>

                                                    {/* {service.description?.en && <div className='htmparser'>{parse(item.serviceID.description[i18n.language])}</div>} */}
                                                    {/* <span className="price">


                                                        {item.discount != 0 && !service.enabledGlobalDiscount ?
                                                            <span className="new">{`${t('aed')} ${item.price - _.round(((item.discount / 100) * item.price), 1)}`} <del className='price-muted font-weight-normal'>{item.serviceID.price}
                                                            </del> </span>
                                                            :
                                                            <span className="new">{t('aed')} {item.serviceID.price} </span>
                                                        }

                                                    </span>
                                                    {item.discount > 0 && !service.enabledGlobalDiscount && <span className='discount badge cart-label font-weight-light'>{item.discount} % {t('discount')}</span>} */}
                                                </div>
                                            </div>
                                        </Link>
                                    )}
                                    {/* <div className="reviews_rating">
                                        <RatingStar maxScore={5} rating={service.rating.rate} id="rating-star-common" />
                                        <span>({service.rating.count} Customer Reviews)</span>
                                    </div> */}

                                    {/* {service.type === 'package' ?
                                        <>
                                            <span className='font-weight-normal align-middle h4'>{`${t('aed')} ${(service.enabledGlobalDiscount) ? service.price - _.round(((service.discount / 100) * service.price), 1) : service.price}`} {service.discount != 0 && service.enabledGlobalDiscount && <del className='price-muted'> {t('aed')} {service.price} </del>}  </span>
                                            {service.discount > 0 && service.enabledGlobalDiscount && <span className='discount badge cart-label font-weight-light align-text-bottom ml-2'>{service.discount} % {t('discount')}</span>}
                                        </>
                                        :

                                        (!service.disablePaymnet && <h4 className='font-weight-normal'>{`${t('aed')} ${service.price - _.round(((service.discount / 100) * service.price), 1)}`} {service.discount != 0 && <del className='price-muted'> {t('aed')} {service.price} </del>}</h4>)

                                    } */}



                                    {/* <div className="customs_selects">
                                        <select name="product" className="customs_sel_box">
                                            <option value="volvo">Size</option>
                                            <option value="xl">XL</option>
                                            <option value="small">S</option>
                                            <option value="medium">M</option>
                                            <option value="learz">L</option>
                                        </select>
                                    </div> */}
                                    {/* <div className="variable-single-item">
                                        <span>Color</span>
                                        <div className="product-variable-color">
                                            <label htmlFor="modal-product-color-red1">
                                                <input name="modal-product-color" id="modal-product-color-red1"
                                                    className="color-select" type="radio" onChange={() => { colorSwatch('red') }} defaultChecked/>
                                                <span className="product-color-red"></span>
                                            </label>
                                            <label htmlFor="modal-product-color-green3">
                                                <input name="modal-product-color" id="modal-product-color-green3"
                                                    className="color-select" type="radio" onChange={() => { colorSwatch('green') }} />
                                                <span className="product-color-green"></span>
                                            </label>
                                            <label htmlFor="modal-product-color-blue5">
                                                <input name="modal-product-color" id="modal-product-color-blue5"
                                                    className="color-select" type="radio" onChange={() => { colorSwatch('blue') }} />
                                                <span className="product-color-blue"></span>
                                            </label>
                                        </div>
                                    </div> */}

                                    {/* <div className="links_Product_areas pt-3">



                                        {productCount > 0 ?
                                            <div>
                                                <ul className='mb-2'>
                                                    <li>
                                                        <a className="action" title="Wishlist" >{t('quantity')}</a>
                                                    </li>
                                                    <li>
                                                        <form id="product_count_form_two">
                                                            <div className="product_count_one">
                                                                <div className="plus-minus-input">
                                                                    <div className="input-group-button">
                                                                        <button type="button" className="button" onClick={onMinus}>
                                                                            <i className="fa fa-minus"></i>
                                                                        </button>
                                                                    </div>
                                                                    <input className="form-control" type="number" value={productCount} readOnly />
                                                                    <div className="input-group-button">
                                                                        <button type="button" className="button" onClick={onPlus}>
                                                                            <i className="fa fa-plus"></i>
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </form>
                                                    </li>

                                                </ul>

                                                <small className='text-adam'><i className="fa fa-check-circle"></i> Added to cart, you can still change the quantity.</small>
                                            </div>

                                            :

                                            (

                                                service.disablePaymnet ?
                                                    <button type="button" className="btn bg-golden px-5" onClick={() => enableBookAppointmentModal(service)}>{t('bookappt')}</button>
                                                    :
                                                    <a className="btn bg-golden px-5" onClick={onPlus}>{t('addtocart')}</a>)}
                                    </div> */}
 {service?.title?.en && <BookingModal type="treatment" servicename={service?.title[i18n.language]} service={service?.id}/>}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="product_details_tabs ">
                                <ul className="nav nav-tabs bg-depart nav nav-tabs px-3 py-2">
                                    <li><a data-toggle="tab" href="#description" className="active">{t('desciption')}</a></li>
                                    {/* {service.type != 'coupon' && <li><a data-toggle="tab" href="#review"> {t('reviews')} {totalcount>0?'('+totalcount+')':''}</a></li>} */}
                                </ul>
                                <div className="tab-content">
                                    <div id="description" className="tab-pane fade in show active">
                                        <div className="product_description">
                                            {service.description?.en && <div className='htmparser'>{parse(service.description[i18n.language])}</div>}
                                            {/* <p>{service.description?.en && service.description[i18n.language]}</p> */}
                                        </div>
                                    </div>

                                    {service.type != 'coupon' && <div id="review" className="tab-pane fade">
                                        <div className='row mt-4'>
                                            {/* <div className='col-lg-2 col-12 text-center'>
                                                <h5> {t('reviews')} ({totalcount})</h5>
                                                <h1>{_.round(averageRating, 1)}</h1>
                                                <RatingStar
                                                    maxScore={5}
                                                    size={24}
                                                    rating={averageRating}
                                                    id="averageRating"
                                                />
                                            </div>
                                            <div className='col-lg-4 col-12'>
                                                <ul className='mt-1'>
                                                    <li className='mb-3'><ProgressBar now={(byrating['1'] / totalcount) * 100} variant="secondary" striped animated={true} /></li>
                                                    <li className='mb-3'><ProgressBar now={(byrating['2'] / totalcount) * 100} variant="secondary" striped animated={true} /></li>
                                                    <li className='mb-3'><ProgressBar now={(byrating['3'] / totalcount) * 100} variant="secondary" striped animated={true} /></li>
                                                    <li className='mb-3'><ProgressBar now={(byrating['4'] / totalcount) * 100} variant="secondary" striped animated={true} /></li>
                                                    <li className='mb-3'><ProgressBar now={(byrating['5'] / totalcount) * 100} variant="secondary" striped animated={true} /></li>
                                                </ul>


                                            </div>
                                            <div className='col-lg-3 col-12'>
                                                <ul>
                                                    <li className='mb-2'>
                                                        <div className="product_review_strat">
                                                            <span><a href="#!"><i className="fa fa-star text-eve"></i></a></span>
                                                            <span><a href="#!"><i className="fa fa-star text-eve"></i></a></span>
                                                            <span><a href="#!"><i className="fa fa-star text-eve"></i></a></span>
                                                            <span><a href="#!"><i className="fa fa-star text-eve"></i></a></span>
                                                            <span><a href="#!"><i className="fa fa-star text-eve"></i></a></span>
                                                            <span className='ml-2'>{_.round((totalcount === 0 ? 0 : (byrating['1'] / totalcount) * 100), 1)}%</span>
                                                        </div>
                                                    </li>
                                                    <li className='mb-2'>
                                                        <div className="product_review_strat">
                                                            <span><a href="#!"><i className="fa fa-star text-eve"></i></a></span>
                                                            <span><a href="#!"><i className="fa fa-star text-eve"></i></a></span>
                                                            <span><a href="#!"><i className="fa fa-star text-eve"></i></a></span>
                                                            <span><a href="#!"><i className="fa fa-star text-eve"></i></a></span>
                                                            <span><a href="#!"><i className="fa fa-star"></i></a></span>
                                                            <span className='ml-2'>{_.round((totalcount === 0 ? 0 : (byrating['2'] / totalcount) * 100), 1)}%</span>
                                                        </div>
                                                    </li>
                                                    <li className='mb-2'>
                                                        <div className="product_review_strat">
                                                            <span><a href="#!"><i className="fa fa-star text-eve"></i></a></span>
                                                            <span><a href="#!"><i className="fa fa-star text-eve"></i></a></span>
                                                            <span><a href="#!"><i className="fa fa-star text-eve"></i></a></span>
                                                            <span><a href="#!"><i className="fa fa-star"></i></a></span>
                                                            <span><a href="#!"><i className="fa fa-star"></i></a></span>
                                                            <span className='ml-2'>{_.round((totalcount === 0 ? 0 : (byrating['3'] / totalcount) * 100), 1)}%</span>
                                                        </div>
                                                    </li>
                                                    <li className='mb-2'>
                                                        <div className="product_review_strat">
                                                            <span><a href="#!"><i className="fa fa-star text-eve"></i></a></span>
                                                            <span><a href="#!"><i className="fa fa-star text-eve"></i></a></span>
                                                            <span><a href="#!"><i className="fa fa-star"></i></a></span>
                                                            <span><a href="#!"><i className="fa fa-star"></i></a></span>
                                                            <span><a href="#!"><i className="fa fa-star"></i></a></span>
                                                            <span className='ml-2'>{_.round((totalcount === 0 ? 0 : (byrating['4'] / totalcount) * 100), 1)}%</span>
                                                        </div>
                                                    </li>
                                                    <li className='mb-2'>
                                                        <div className="product_review_strat">
                                                            <span><a href="#!"><i className="fa fa-star text-eve"></i></a></span>
                                                            <span><a href="#!"><i className="fa fa-star"></i></a></span>
                                                            <span><a href="#!"><i className="fa fa-star"></i></a></span>
                                                            <span><a href="#!"><i className="fa fa-star"></i></a></span>
                                                            <span><a href="#!"><i className="fa fa-star"></i></a></span>
                                                            <span className='ml-2'>{_.round((totalcount === 0 ? 0 : (byrating['5'] / totalcount) * 100), 1)}%</span>
                                                        </div>
                                                    </li>


                                                </ul>


                                            </div> */}
                                            <div className='col-lg-12 col-12 text-right'>
                                           <span className='h5 font-weight-light text-capitalize'>{t('writereview')}  <button className='btn btn-link' onClick={openReviewModal}>
                                                      <img src={pencilgray} style={{ height: 30 }} />
                                                </button></span>    
                                            </div>
                                        </div>
                                        <div className="product_reviews">
                                            <ul>
                                                {props?.feedbacks?.map((data, index) => (
                                                    <li className="media" key={index}>
                                                        <div className="media-img">
                                                            <Avatar name={data.name} size={50} color="#ccc" round="50px" />

                                                            {/* <img src={process.env.REACT_APP_IMG_URL + data?.customer?.avatar} /> */}
                                                        </div>
                                                        <div className="media-body">
                                                            <div className="media-header">
                                                                <div className="media-name">
                                                                    <h4>{data.name}</h4>
                                                                    <p className='small text-black-50'>{moment(data.createdDate).format("DD MMM yy LT")}</p>
                                                                </div>
                                                                <div className="post-share">
                                                                    <div className='small'>Rating
                                                                        <RatingStar
                                                                            maxScore={5}
                                                                            size={16}
                                                                            rating={parseInt(data.rating)}
                                                                            id={index}
                                                                        />
                                                                        {parseInt(data.rating)}
                                                                    </div>

                                                                </div>
                                                            </div>
                                                            <div className="media-pragraph">
                                                                {/* <div className='ml-n2 mt-n3'>
                                                                    <RatingStar
                                                                        maxScore={5}
                                                                        size={24}
                                                                        rating={parseInt(data.rating)}
                                                                        id={index}
                                                                    />

                                                                </div> */}

                                                                {/* <div className="product_review_strat">
                                                                    <span><a href="#!"><i className="fa fa-star"></i></a></span>
                                                                    <span><a href="#!"><i className="fa fa-star"></i></a></span>
                                                                    <span><a href="#!"><i className="fa fa-star"></i></a></span>
                                                                    <span><a href="#!"><i className="fa fa-star"></i></a></span>
                                                                    <span><a href="#!"><i className="fa fa-star"></i></a></span>
                                                                </div> */}
                                                                <p>{data.description}</p>
                                                            </div>
                                                        </div>
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                    </div>}
                                </div>
                            </div>
                        </div>
                    </div>
                    {props?.randomPackages?.length > 0 && <TodayDeal data={props?.randomPackages} heading={2} hidebooking={true} title="Recommended" />}
                    <Modal show={showReviewModal} onHide={closeReviewModal} centered={true}>

                        <Modal.Body>

                            <a className='float-right' onClick={closeReviewModal}><IoCloseCircle color='#838383' /></a>
                            <div className='row'>
                                <div className='col-lg-12 col-12 text-center mb-1'>
                                    <div>
                                        <img src={pencil} style={{ height: 60 }} />
                                        <Modal.Title>{t('writereview')}</Modal.Title>

                                    </div>
                                    <div className="md-stepper-horizontal orange px-5">
                                        <div className={`md-step ${step === 11 ? "active" : ""}` + `${step > 11 ? " done" : ""}`}>
                                            <div className="md-step-circle"><span>1</span></div>

                                            <div className="md-step-bar-left"></div>
                                            <div className="md-step-bar-right"></div>
                                        </div>
                                        <div className={`md-step ${step === 12 ? "active" : ""}` + `${step > 12 ? " done" : ""}`}>
                                            <div className="md-step-circle"><span>2</span></div>

                                            <div className="md-step-bar-left"></div>
                                            <div className="md-step-bar-right"></div>
                                        </div>
                                        <div className={`md-step ${step === 13 ? "active" : ""}` + `${step > 13 ? " done" : ""}`}>
                                            <div className="md-step-circle"><span>3</span></div>

                                            <div className="md-step-bar-left"></div>
                                            <div className="md-step-bar-right"></div>
                                        </div>

                                    </div>


                                </div>
                                {step === 11 && <div className='col-lg-12 col-12'>
                                    <div className='text-center'>
                                        <RatingStar
                                            clickable
                                            maxScore={5}
                                            size={50}
                                            rating={rating}
                                            onRatingChange={onRatingChange}
                                            id="selectRating"
                                        />
                                    </div>

                                    <div className="form-group mt-4">

                                        <textarea className="form-control" rows="5" placeholder='Tell us about your own personal experince taking this treatment?' onChange={(e) => setReviewDesc(e.target.value)}></textarea>
                                    </div>

                                    <button className='btn btn-block bg-eve mt-4' disabled={!reviewDesc || rating === 0} onClick={() => setStep(12)}>
                                        Next
                                    </button>
                                </div>}

                                {step === 12 && <div className='col-lg-12 col-12'>

                                    <div class="form-group mb-4">
                                        <input type="text" class="form-control" onChange={(e) => setName(e.target.value)} placeholder='Name' />
                                    </div>

                                    <div class="form-group mb-4">
                                        <input type="text" class="form-control" onChange={(e) => setEmail(e.target.value)} placeholder='Email' />
                                    </div>

                                 
                                    <div className="default-form-box mb-3">
                             
                                <PhoneInput
                                    country={'ae'}
                                    value={mobile}
                                    onChange={handleMobileChange}
                                    inputclassName="w-100"
                                    minLength="10"
                                    inputProps={{required: true, minLength:"10"}}
                                />
                            </div>

                                    <button className='btn btn-block bg-eve mt-4' onClick={submitReview}>
                                        Submit
                                    </button>
                                </div>}
                                {step === 13 && <div className='col-lg-12 col-12 text-center'>
                                    <p>Your review has been submitted for admin approval, it will be published post approval.</p>
                                    <Button className='btn-block mt-4' variant="secondary" onClick={closeReviewModal}>
                                        Close
                                    </Button>
                                </div>}
                                {/* <div className='col-lg-6 col-6'>
                                    <Button className='btn-block' variant="secondary" onClick={closeReviewModal}>
                                        Close
                                    </Button>

                                </div> */}
                                {/* <div className='col-lg-12 col-12'>

                                    <button className='btn btn-block bg-eve' onClick={submitReview}>
                                        Submit
                                    </button>
                                </div> */}
                                <ToastContainer />
                            </div>
                        </Modal.Body>

                    </Modal>
                </div>
            </section>

            <Modal show={show} onHide={handleClose} centered>
                <Modal.Header closeButton>
                    <Modal.Title>{t('bookappt')}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className='row'>
                        <div className='col-lg-6'>


                            <div className="form-group">
                                <label for="exampleInputEmail1">{t('date')}</label>
                                <DatePicker className="btn-block form-control"
                                    minDate={new Date()}
                                    selected={selected}
                                    onChange={(date) => setSelected(date)} />

                            </div>
                        </div>
                        <div className='col-lg-6'>
                            <div className="form-group">
                                <label>{t('time')}</label>

                                <select className="form-control" onChange={(e) => setSelectedSlot(e.target.value)}>
                                    <option>Choose</option>
                                    {slots.map((e, index) => <option key={index} value={e.value} disabled={e.disabled}>{e.name}</option>)}
                                </select>
                            </div>
                        </div>
                        <div className='col-lg-12'>

                            <small className="form-text text-muted">Date & time will be confirmed by our customer service agent</small>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    {/* <button type="button" className="btn btn-secondary" data-dismiss="modal">Close</button> */}
                    <button type="button" className="btn bg-adam" onClick={confirmBooking}>{t('booknow')}</button>
                </Modal.Footer>
            </Modal>
            {/* <RelatedProduct /> */}
        </>
    )
}

const mapStateToProps = state => ({

    users: state.user.users,
    cart: state.user.cart,
    cartArray: state.user.cartArray,
    currentService: state.service.currentService,
    feedbacks: state.feedback.feedbacks,
    feedbacksMeta: state.feedback.meta,
    randomPackages: state?.service?.randomPackages,
})

const mapActionToProps = {
    update: actions.update,
    fetchById: actions.fetchById,
    updateUser: user.update,
    updateUserCart: user.updateCart,
    fetchCart: user.fetchCart,
    addReview: feedback.create,
    fetchRating: feedback.fetchAll,
    getByServiceId: feedback.getByServiceId,
    fetchRandomPackages: actions.fetchRandomPackages,

}

export default connect(mapStateToProps, mapActionToProps)(ProductDetailsOne);